/**
 * Was sich geaendert hat (PV-B24).
 *
 * Verstaendliche Sprache, direkt in der Anwendung lesbar — das ist die
 * Verbindung zum Ticketsystem: was gemeldet wurde und was daraus geworden ist.
 *
 * Die Datei wird beim Bauen mit ins Programmpaket gelegt und liegt damit auch
 * ohne Verbindung auf dem Geraet.
 */

import { useEffect, useState } from 'react';

export function Changelog({
  version,
  onSchliessen,
}: {
  version: string;
  onSchliessen: () => void;
}): React.JSX.Element {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    void fetch('/changelog.md')
      .then((antwort) => (antwort.ok ? antwort.text() : Promise.reject(new Error('nicht da'))))
      .then(setText)
      .catch(() => setText('Der Changelog konnte nicht geladen werden.'));
  }, []);

  return (
    <div
      role="dialog"
      aria-label="Was sich geändert hat"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.4)',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1.5rem',
      }}
      onClick={onSchliessen}
    >
      <div
        style={{
          background: 'var(--weiss)',
          maxWidth: '38rem',
          width: '100%',
          maxHeight: '80vh',
          overflow: 'auto',
          padding: '1.75rem',
          border: '1px solid var(--schwarz)',
        }}
        onClick={(ereignis) => ereignis.stopPropagation()}
      >
        <p className="marke">Laufende Version {version}</p>
        <h2>Was sich geändert hat</h2>
        {text === null ? <p>Einen Moment …</p> : <Markdown text={text} />}
        <button className="wichtig" onClick={onSchliessen} style={{ marginTop: '1.5rem' }}>
          Schließen
        </button>
      </div>
    </div>
  );
}

/**
 * Genau so viel Markdown, wie der Changelog braucht. Eine Bibliothek dafuer
 * mitzuliefern waere ein halbes Megabyte fuer Ueberschriften und Aufzaehlungen.
 */
function Markdown({ text }: { text: string }): React.JSX.Element {
  const zeilen = text.split('\n');
  const teile: React.JSX.Element[] = [];
  let liste: string[] = [];

  const listeAbschliessen = (schluessel: number): void => {
    if (liste.length === 0) return;
    teile.push(
      <ul key={`liste-${schluessel}`}>
        {liste.map((eintrag, i) => (
          <li key={i}>{eintrag}</li>
        ))}
      </ul>,
    );
    liste = [];
  };

  zeilen.forEach((zeile, index) => {
    if (zeile.startsWith('## ')) {
      listeAbschliessen(index);
      teile.push(
        <h3 key={index} style={{ margin: '1.5rem 0 0.5rem' }}>
          {zeile.slice(3)}
        </h3>,
      );
    } else if (zeile.startsWith('# ')) {
      listeAbschliessen(index);
    } else if (zeile.startsWith('- ')) {
      liste.push(zeile.slice(2));
    } else if (zeile.trim() === '') {
      listeAbschliessen(index);
    } else {
      listeAbschliessen(index);
      teile.push(
        <p key={index} style={{ fontSize: '0.9rem' }}>
          {zeile}
        </p>,
      );
    }
  });
  listeAbschliessen(zeilen.length);

  return <div>{teile}</div>;
}
